import axios from "axios";
// 0️⃣
let baseURL;
if (typeof window === "undefined") {
  baseURL = "http://localhost:3000/api/";
} else if (
  window.location.href.includes("testpay") ||
  window.location.href.includes("localhost")
) {
  baseURL =
    "https://testapegaautomsgstandby-c6ffaqetc5b6ach4.canadacentral-01.azurewebsites.net/api/";
} else {
  baseURL = "https://apegaautomsgstandby.azurewebsites.net/api/";
}
const instance = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
// 1️⃣
export const fetchBill = (billId) => {
  const encodedBillId = encodeURIComponent(billId);
  return instance.post(`/pay_Moneris3DS/FetchBill?bill=${encodedBillId}`);
};
// 2️⃣
export const cardLookUp = (billId, cardData) => {
  const encodedBillId = encodeURIComponent(billId);
  const requestBody = new URLSearchParams();
  Object.entries(cardData).forEach(([key, value]) => {
    requestBody.append(key, value);
  });

  return instance.post(
    `/pay_Moneris3DS/CardLookup?bill=${encodedBillId}`,
    requestBody
  );
};

// 3️⃣
// export const threeDSAuth = (orderId, amt) => {
//   const encodedOrderId = encodeURIComponent(orderId);
//   const encodedAmt = encodeURIComponent(amt);

//   return instance.post(
//     `/pay_Moneris3DS/ThreeDSAuth?orderId=${encodedOrderId}&amt=${encodedAmt}`
//   );
// };
//hardcoded
// const threeDSData = {
//   tci: "U",
//   ChallengeWindowSize: "02",
//   JavaEnabled: "false",
//   ScreenHeight: "1080",
//   ScreenWidth: "1920",
//   Language: "en",
//   UserAgent:
//     "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36",
// };

export const threeDSAuth = (orderId, amt) => {
  const encodedOrderId = encodeURIComponent(orderId);
  const encodedAmt = encodeURIComponent(amt);

  const userAgent = encodeURIComponent(
    "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36"
  ).replace(/%20/g, "+");

  const threeDSData = `tci=U&ChallengeWindowSize=02&JavaEnabled=false&ScreenHeight=1080&ScreenWidth=1920&Language=en&UserAgent=${userAgent}`;

  return instance.post(
    `/pay_Moneris3DS/ThreeDSAuth?orderId=${encodedOrderId}&amt=${encodedAmt}`,
    threeDSData,
    {
      headers: {
        "Content-Type": "text/plain",
      },
    }
  );
};
// 4️⃣
export const postRawData = (cnum_oaid, amt, cardData, order_id, systag) => {
  const requestBody = {
    // systag: "alpha/postpaid",
    order_id: order_id,
    systag: systag,
    cnum_oaid: cnum_oaid,
    amount: amt,
    currency: "CAD",
    crnum: cardData.CreditCardNumber,
    crexpyyyymm: `${cardData.ExpirationYear}${cardData.ExpirationMonth}`,
    cvv: cardData.CCV,
    isTest: false,
    crholder: cardData.CreditCardName,
  };

  return instance.post(`/pay_MonerisController/PostRawData`, requestBody);
};
export default instance;
